import { getDateFromString, getStringFromDate, getDaysInYear, daysDiff } from './Date';
import { UNITE, UNITE_TEMPS } from './Global';

const getBornes = (tarification) => {
	const today = new Date();

	const firstDate = new Date(today.getFullYear(), 0, 1);
	const lastDate = new Date(today.getFullYear(), 11, 31);

	const dateDebutContrat = tarification.dateDebutContrat ? getDateFromString(tarification.dateDebutContrat) : null;
	const borneInf = dateDebutContrat == null || dateDebutContrat < firstDate || dateDebutContrat > lastDate ? firstDate : dateDebutContrat;

	const dateFinContrat = tarification.dateFinContrat ? getDateFromString(tarification.dateFinContrat) : null;
	const borneSup = dateFinContrat == null || dateFinContrat > lastDate || dateFinContrat < firstDate ? lastDate : dateFinContrat;

	const isOutOfRange = (dateDebutContrat > lastDate || dateFinContrat < firstDate);

  return {
    dateInf: borneInf,
    dateSup: borneSup,
		isOutOfRange: isOutOfRange,
  }
}

export const getTarificationRows = (tarification, tarif) => {
  const rows = [];

  if(!tarif && !tarification.tarif)
    return null;

  const { dateInf, dateSup, isOutOfRange } = getBornes(tarification);

	let isOutOfRangeBool=isOutOfRange;

  let { borneInf, borneSup } = { borneInf: dateInf, borneSup: dateSup };




  const currentTarif = tarif ? tarif : tarification.tarif;
  const dateDebutTarif = currentTarif.dateValiditeDebut ? getDateFromString(currentTarif.dateValiditeDebut) : null;
  const dateFinTarif = currentTarif.dateValiditeFin ? getDateFromString(currentTarif.dateValiditeFin) : null;
  let lookForParentTarif = false;



	if(dateDebutTarif != null && dateDebutTarif > borneInf) {
		if (borneSup<dateDebutTarif){
			borneInf=borneSup;
			borneSup=dateDebutTarif
		}
		else {
			borneInf = dateDebutTarif;
		}
		lookForParentTarif = true;
	}

	if(dateFinTarif != null && dateFinTarif < borneSup) {
		if (borneInf>dateFinTarif)
		{
			borneSup = borneInf;
			borneInf=dateFinTarif
		}
		else {
			borneSup = dateFinTarif;
		}


	}
	if (borneInf<dateInf||borneSup>dateSup)
	{
		 isOutOfRangeBool=true
	}




	if ( isOutOfRangeBool)
	console.log('borneInf' + '/' + borneInf.toString() )
	console.log('dateSup' + '/' + borneSup.toString() )


	// console.log("----------------------");
	// console.log("Calcul du tarif du " + getStringFromDate(borneInf) + " au " + getStringFromDate(borneSup));

	let dimension = 1.0;
	if((!currentTarif.unite && tarification.surface !== null)
	   || (currentTarif.unite && currentTarif.unite.titre !== UNITE.FORFAIT)) {
		dimension = tarification.surface;
	}

	let prix = currentTarif.valeur;
	let currentRecette = 0.0;
	let numberOfDays = 0;

	// console.log("Unite de temps : " + currentTarif.uniteTemps.libelle);

	//console.log('lastDateOfMonth' + '/' + lastDateOfMonth.toString() )

	if(! isOutOfRangeBool) {
		switch(currentTarif.uniteTemps.libelle) {
			case UNITE_TEMPS.YEAR :
				const today = new Date();
				numberOfDays = daysDiff(borneInf, borneSup) + 1;
				currentRecette = prix * dimension * numberOfDays / getDaysInYear(today.getFullYear());
				break;

			case UNITE_TEMPS.MONTH :
				let firstDateOfMonth = new Date(borneInf.getFullYear(), borneInf.getMonth(), 1);
				let lastDateOfMonth = new Date(borneInf.getFullYear(), borneInf.getMonth() + 1, 0);

				do {
					// console.log(getStringFromDate(firstDateOfMonth));
					// console.log(getStringFromDate(lastDateOfMonth));

					numberOfDays = lastDateOfMonth.getDate();
					if(lastDateOfMonth > borneSup)
						numberOfDays = borneSup.getDate();

					if(firstDateOfMonth < borneInf)
						numberOfDays -= daysDiff(firstDateOfMonth, borneInf);

					// console.log("Mois N°" + firstDateOfMonth.getMonth() + " : " + numberOfDays + " jours\n");
					// console.log("Recette : " + prix + " x " + dimension + " x " + numberOfDays + " / " + lastDateOfMonth.getDate() + "\n");

					currentRecette += prix * dimension * numberOfDays / lastDateOfMonth.getDate();




					firstDateOfMonth.setMonth(firstDateOfMonth.getMonth() + 1);
					lastDateOfMonth.setMonth(firstDateOfMonth.getMonth() + 1);
					lastDateOfMonth.setDate(0);
				} while (!(firstDateOfMonth > borneSup));

				break;

			case UNITE_TEMPS.WEEK :
				numberOfDays = daysDiff(borneInf, borneSup) + 1;
				currentRecette = prix * dimension * numberOfDays / 7;
				break;

			case UNITE_TEMPS.DAY :
				numberOfDays = daysDiff(borneInf, borneSup) + 1;
				currentRecette = prix * dimension * numberOfDays;
				break;
			default:
				break;
		}

		currentRecette = Math.round(currentRecette * 100.0) / 100.0;
	}

	// console.log("Prix : " + prix + " | Dimension : " + dimension + " | Recette : " + currentRecette);

	if(lookForParentTarif && currentTarif.tarifParent) {
    const previousRows = getTarificationRows(tarification, currentTarif.tarifParent);
    if(previousRows) {
			while(previousRows.length > 0) {
				let obj = previousRows.shift();
	      obj.index = rows.length;
	      rows.push(obj);
			}
    }
  }

  let recetteWithRemise = currentRecette;
  if(tarification.remise1 && ! isOutOfRangeBool)
    recetteWithRemise -= recetteWithRemise * tarification.remise1 / 100;
  if(tarification.remise2 && ! isOutOfRangeBool)
    recetteWithRemise -= recetteWithRemise * tarification.remise2 / 100;

  recetteWithRemise = Math.round(recetteWithRemise * 100.0) / 100.0;

	if (!isOutOfRangeBool)
	{
		rows.push({
	    index: rows.length,
	    dateDebut: getStringFromDate(borneInf),
	    dateFin: getStringFromDate(borneSup),
	    surface: tarification.surface,
	    tarif: currentTarif ? currentTarif.valeur : null,
	    sousTotal: currentRecette,
	    remise1: tarification.remise1,
	    remise2: tarification.remise2,
	    totalAnnuel: recetteWithRemise,
	    estFacture: tarification.estFacture ? "Oui" : "Non",
	    estSousLoue: tarification.estSousLoue ? "Oui" : "Non",
	  });

	}



  if(!tarif && rows.length > 1) {
    let sousTotal = 0, totalAnnuel = 0;
    rows.forEach(row => {
      sousTotal += row.sousTotal;
      totalAnnuel += row.totalAnnuel;
    });

    sousTotal = Math.round(sousTotal * 100.0) / 100.0;
    totalAnnuel = Math.round(totalAnnuel * 100.0) / 100.0;

    rows.push({
      index: rows.length,
      dateDebut: getStringFromDate(dateInf),
      dateFin: getStringFromDate(dateSup),
      surface: tarification.surface,
      tarif: tarif ? tarif.valeur : null,
      sousTotal: sousTotal,
      remise1: tarification.remise1,
      remise2: tarification.remise2,
      totalAnnuel: totalAnnuel,
      estFacture: tarification.estFacture ? "Oui" : "Non",
      estSousLoue: tarification.estSousLoue ? "Oui" : "Non",
    });
  }

  return rows;
}



// WEBPACK FOOTER //
// ./src/Utils/Tarification.js